import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "invoiceFilled"
const InvoiceFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M18.75 1.5C19.578 1.5 20.25 2.172 20.25 3V20.425C20.25 21.591 18.978 22.312 17.978 21.712L15.75 20.375 12.772 22.162C12.297 22.447 11.703 22.447 11.228 22.162L8.25 20.375 6.022 21.712C5.022 22.312 3.75 21.59 3.75 20.425V3C3.75 2.172 4.422 1.5 5.25 1.5zM7.5 15.75C7.086 15.75 6.75 16.086 6.75 16.5S7.086 17.25 7.5 17.25H13.5C13.914 17.25 14.25 16.914 14.25 16.5S13.914 15.75 13.5 15.75zM7.5 12.75C7.086 12.75 6.75 13.086 6.75 13.5S7.086 14.25 7.5 14.25H16.5C16.914 14.25 17.25 13.914 17.25 13.5S16.914 12.75 16.5 12.75zM10.831 3.75C9.335 3.75 8.173 4.719 7.702 6.094H6.75V7.239H7.482V7.761H6.75V8.906H7.692C8.162 10.312 9.324 11.25 10.852 11.25 12.056 11.25 12.882 10.677 13.5 9.834L12.453 9.052C12.108 9.625 11.553 10 10.853 10 10.12 10 9.491 9.594 9.197 8.906H11.68V7.761H8.906C8.895 7.677 8.896 7.594 8.896 7.5 8.895 7.417 8.894 7.323 8.905 7.24H11.679V6.093H9.22C9.545 5.406 10.142 5 10.853 5 11.428 5 11.91 5.302 12.244 5.792L13.259 4.969C12.684 4.219 11.857 3.75 10.831 3.75"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default InvoiceFilledIcon
